import { z } from 'zod';

export const Price = z.object({
  amount: z.number(),
  currencyCode: z.string(),
  prefix: z.string().optional(),
  suffix: z.string().nullish(),
});
